import styled from "styled-components";
import { media } from "../../../../../components/common/media";
import bg from "../../../../../images/custom-solutions-bg.png";
const CustomSolutionsContainer = styled.div`
  background: url(${bg}) top center;
  background-size: cover;
  height: 385px;
  position: relative;
  .custom-solutions-text {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 15%;
    ${media.desktop`
      left: 25px;
    `};
    h3 {
      color: #fff;
      font-weight: 400;
      font-size: 50px;
      ${media.tablet`
        font-size: 36px;
      `};
      ${media.phone`
        font-size: 28px;
      `};
    }
    a {
      font-size: 20px;
      color: ${(props) => props.theme.colors.primary.main}
      ${media.phone`
        font-size: 16px;
      `};
      svg {
          width: 20px;
          margin-left: 10px;
      }
    }
  }
`;

export default CustomSolutionsContainer;
